import Image from 'next/image';
import React, { SyntheticEvent } from 'react';

export type ActionIconProps = {
    className?: string;
    icon: React.JSX.Element | string;
    tooltipText?: string;
    // tooltipDirection?: TooltipDirection;
    action: (event: SyntheticEvent) => void;
};

export function ActionIcon(props: ActionIconProps): React.JSX.Element {
    const { icon, action } = props;
    const iconWithAction = (
        <button
            aria-label={props.tooltipText ?? 'Action Icon'}
            className="relative flex w-24 h-24 items-center clickable-element"
            onClick={action}>
            {typeof icon === 'string' ? (
                <Image
                    className="object-cover"
                    layout="fill"
                    src={icon}
                    alt="Action Icon"
                />
            ) : React.isValidElement(icon) ? (
                icon
            ) : null}
        </button>
    );
    return (
        <div className={`flex items-center ${props.className || ''}`}>
            {props.tooltipText
                ? // <Tooltip
                  //     tooltipText={props.tooltipText || ''}
                  //     direction={props.tooltipDirection || TooltipDirection.Top}>
                  //     {
                  iconWithAction
                : // }
                  // </Tooltip>
                  iconWithAction}
        </div>
    );
}
